import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="container row-spacing">
      <div className="row">
        <div className="col">
          <hr className="hrline" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <p className="light-color">
            © 2022 by Rohan Singh. All rights reserved.
          </p>
        </div>
        <div className="col">
          <p className="light-color">NeoHacks 2.0</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
